import { render, staticRenderFns } from "./ShowLink.vue?vue&type=template&id=62677552&lang=true"
import script from "./ShowLink.vue?vue&type=script&lang=js"
export * from "./ShowLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports